<template>
  <div>
    <v-dialog v-model="dialogData" width="500" persistent>
      <v-card>
        <v-card-title>
          {{ formTitle }}
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Kode Bank </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    id="bank_code"
                    ref="bank_code"
                    v-model="editedItemData.bank_code"
                    @change="$v.editedItemData.bank_code.$touch()"
                    @blur="$v.editedItemData.bank_code.$touch()"
                    :error-messages="bankCodeErrors"
                  />
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Kode NNS </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    id="bank_nns"
                    ref="bank_nns"
                    v-model="editedItemData.bank_nns"
                    @change="$v.editedItemData.bank_nns.$touch()"
                    @blur="$v.editedItemData.bank_nns.$touch()"
                    :error-messages="bankNnsErrors"
                  />
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Nama PJSP </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    id="bank_name"
                    ref="bank_name"
                    v-model="editedItemData.bank_name"
                    @change="$v.editedItemData.bank_name.$touch()"
                    @blur="$v.editedItemData.bank_name.$touch()"
                    :error-messages="bankNameErrors"
                  />
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Brand Name </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    id="brand_name"
                    ref="brand_name"
                    v-model="editedItemData.brand_name"
                    @change="$v.editedItemData.brand_name.$touch()"
                    @blur="$v.editedItemData.brand_name.$touch()"
                    :error-messages="brandNameErrors"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="cancelDialog"> Cancel </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="loading"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  maxLength,
  minLength,
  numeric,
} from 'vuelidate/lib/validators';
import { isEmpty, date, showAlert } from '../../lib/helpers';

export default {
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
    dialogNNS: {
      type: Boolean,
      default: false,
    },
    editedIndex: {
      type: Number,
      default: null,
    },
  },
  mixins: [validationMixin],
  validations: {
    editedItemData: {
      bank_code: {
        required,
        numeric,
        maxLength: maxLength(4),
        minLength: minLength(3),
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.bank_code == null ||
              this.errorValidation.bank_code.length < 1)
          );
        },
      },
      bank_nns: {
        required,
        numeric,
        maxLength: maxLength(8),
        minLength() {
          if (this.editedItemData.bank_nns.length > 0) {
            return this.editedItemData.bank_nns.length == 8;
          }
          return true;
        },
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.bank_nns == null ||
              this.errorValidation.bank_nns.length < 1)
          );
        },
      },
      bank_name: {
        required,
      },
      brand_name: {
        required,
      },
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    editedItemData: {
      get() {
        return this.editedItem;
      },
      set(newValue) {
        this.$emit('update:editedItem', newValue);
      },
    },
    dialogData() {
      return this.dialogNNS;
    },
    formTitle() {
      return this.editedIndex != -1 ? 'Edit NNS' : 'Add NNS';
    },
    flashErrorMessage() {
      const errorData = this.errorValidation.message
        ? this.errorValidation.message
        : this.$store.state.nnsManagement.flashErrorMessage;
      return errorData;
    },

    flashError: {
      get() {
        return this.$store.state.nnsManagement.flashError;
      },
      set() {
        this.$store.commit('nnsManagement/setFlashErrorMessage', '');
      },
    },
    errorValidation() {
      return this.$store.state.nnsManagement.errors;
    },
    loading() {
      return this.$store.state.nnsManagement.loading;
    },
    bankCodeErrors() {
      const errors = [];
      if (!this.$v.editedItemData.bank_code.$dirty) return errors;
      if (!this.$v.editedItemData.bank_code.numeric) {
        errors.push('Must be numeric');
      }
      if (!this.$v.editedItemData.bank_code.required) {
        errors.push('Bank Code is required');
      }
      if (!this.$v.editedItemData.bank_code.maxLength) {
        errors.push("Bank Code can't more then 4 digit");
      }
      if (!this.$v.editedItemData.bank_code.minLength) {
        errors.push("Bank Code can't less then 3 digit");
      }
      if (!this.$v.editedItemData.bank_code.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.bank_code != null
        ) {
          this.errorValidation.bank_code.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    bankNnsErrors() {
      const errors = [];
      if (!this.$v.editedItemData.bank_nns.$dirty) return errors;
      if (!this.$v.editedItemData.bank_nns.numeric) {
        errors.push('Must be numeric');
      }
      if (!this.$v.editedItemData.bank_nns.required) {
        errors.push('Bank NNS is required');
      }
      if (!this.$v.editedItemData.bank_nns.maxLength) {
        errors.push('Bank NNS must be 8 digit');
      }
      if (!this.$v.editedItemData.bank_nns.minLength) {
        errors.push('Bank NNS must be 8 digit');
      }
      if (!this.$v.editedItemData.bank_nns.isUnique) {
        if (this.errorValidation && this.errorValidation.bank_nns) {
          this.errorValidation.bank_nns.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    bankNameErrors() {
      const errors = [];
      if (!this.$v.editedItemData.bank_name.$dirty) return errors;
      if (!this.$v.editedItemData.bank_name.required) {
        errors.push('Bank Name is required');
      }
      return errors;
    },
    brandNameErrors() {
      const errors = [];
      if (!this.$v.editedItemData.brand_name.$dirty) return errors;
      if (!this.$v.editedItemData.brand_name.required) {
        errors.push('Brand Name is required');
      }
      return errors;
    },
  },
  watch: {
    dialogNNS(val) {
      if (!val) this.cancelDialog();
    },
    'editedItemData.bank_code': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.bank_code != null &&
            val != this.errorValidation.bank_code
          ) {
            this.$store.commit('nnsManagement/clearErrorVariable', 'bank_code');
          }
        }
      },
    },
    'editedItemData.bank_nns': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.bank_nns != null &&
            val != this.errorValidation.bank_nns
          ) {
            this.$store.commit('nnsManagement/clearErrorVariable', 'bank_nns');
          }
        }
      },
    },
    'editedItemData.bank_name': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.bank_name != null &&
            val != this.errorValidation.bank_name
          ) {
            this.$store.commit('nnsManagement/clearErrorVariable', 'bank_name');
          }
        }
      },
    },
    'editedItemData.brand_name': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.brand_name != null &&
            val != this.errorValidation.brand_name
          ) {
            this.$store.commit(
              'nnsManagement/clearErrorVariable',
              'brand_name'
            );
          }
        }
      },
    },
  },
  methods: {
    cancelDialog() {
      this.resetUniqueValidation();
      this.$emit('closeCancelParent');
    },
    resetUniqueValidation() {
      this.$store.commit('nnsManagement/clearErrors');
    },
    close() {
      this.dialog = false;
    },
    async save() {
      this.$store.commit('nnsManagement/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const dataForm = this.editedItemData;
        if (this.editedIndex > -1) {
          await this.$store
            .dispatch('nnsManagement/updateNns', {
              date,
              dataForm,
              index: this.editedIndex,
            })
            .then((status) => {
              if (status) {
                this.cancelDialog();
                showAlert(
                  this.$store,
                  'Update NNS success !',
                  'mdi-check-circle',
                  'green'
                );
              } else {
                showAlert(
                  this.$store,
                  'Error on update NNS !',
                  'mdi-alert',
                  'red'
                );
              }
            });
        } else {
          await this.$store
            .dispatch('nnsManagement/addNns', {
              date,
              dataForm,
            })
            .then((status) => {
              if (status) {
                this.cancelDialog();
                showAlert(
                  this.$store,
                  'Add NNS success !',
                  'mdi-check-circle',
                  'green'
                );
              } else {
                showAlert(
                  this.$store,
                  'Error on Add NNS !',
                  'mdi-alert',
                  'red'
                );
              }
            });
        }
      }
    },

    isEmpty,
  },
};
</script>
